import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/icon-pod.svg'
import _imports_1 from '@/app/ui/assets/svg/sti-reverse-scan/icon-dangerous-goods.svg'
import _imports_2 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti-dest.svg'
import _imports_3 from '@/app/ui/assets/svg/sti-reverse-scan/icon-sti.svg'


const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-2" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "POD HARI INI!"
}
const _hoisted_3 = { class: "flex flex-row items-center justify-center gap-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "dangerous-goods-icon",
  width: "140"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  alt: "sti-sti-dest-icon",
  width: "180"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_3,
  alt: "sti-icon",
  width: "95"
}
const _hoisted_7 = {
  key: 1,
  class: "px-4 py-2 rounded-full bg-green-lp-100 text-white text-2xl font-bold"
}
const _hoisted_8 = {
  key: 2,
  class: "text-red-lp-500 text-xl font-semibold"
}
const _hoisted_9 = {
  key: 3,
  class: "text-red-lp-500 text-xl font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isPod)
      ? (_openBlock(), _createBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.isStiDest)
        ? (_openBlock(), _createBlock("img", _hoisted_5))
        : (_openBlock(), _createBlock("img", _hoisted_6)),
      _createVNode("img", {
        src: _ctx.combinedLabelAsset,
        alt: _ctx.isForeignAccount ? 'Dangerous Goods and Woodpacking' : 'Packing Kayu dan Dangerous Goods',
        width: "190"
      }, null, 8, ["src", "alt"])
    ]),
    (_ctx.regionName)
      ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.regionName), 1))
      : _createCommentVNode("", true),
    (_ctx.isOverdue)
      ? (_openBlock(), _createBlock("div", _hoisted_8, " Batas POD Terlewati "))
      : (_ctx.isUrgent)
        ? (_openBlock(), _createBlock("div", _hoisted_9, " Kiriman Penting "))
        : _createCommentVNode("", true)
  ]))
}